import { INotification, notificationEnums } from "@freetech/models/notifications";
import {
  getStakeholderNotificationTitle,
  getFreelancerNotificationTitle,
  getAdminNotificationTitle,
  getFreeloNotificationTitle,
} from "./modules";

export const getNotificationTitle = (notification: INotification): string => {
  const { type } = notification;

  if (Object.values(notificationEnums.StakeholderNotificationType).includes(type as any)) {
    return getStakeholderNotificationTitle(notification) || "New notification";
  }

  if (Object.values(notificationEnums.FreelancerNotificationType).includes(type as any)) {
    return getFreelancerNotificationTitle(notification) || "New notification";
  }

  if (Object.values(notificationEnums.AdminNotificationType).includes(type as any)) {
    return getAdminNotificationTitle(notification) || "New notification";
  }

  if (Object.values(notificationEnums.FreeloNotificationType).includes(type as any)) {
    return getFreeloNotificationTitle(notification) || "New notification";
  }

  return "New notification";
}; 